import React from 'react';
import WrappedBase from './WrappedBase';

import AddToCartSuccessModal from '../containers/AddToCartSuccessModal';

export default class AddToCartSuccessModalWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <AddToCartSuccessModal />
      </WrappedBase>
    );
  }
}
